<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <aside :class="['right-sidebar', showSidebar ? 'show' : '']">
    <div class="sidebar-content">
      <div class="sb-top">
        <div class="f-34">
          All Filters
        </div>
        <button type="button" @click="showSidebar = false">
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="img-size-12"
          >
        </button>
      </div>
      <div class="sb-body">
        <div
          v-for="(option, idx) in orderFilter"
          :key="idx"
        >
          <div v-if="option.key !== 'branch'">
            <div class="sac__font-14 semi-bold margin-bottom-16 flex-row">
              {{ option.label }}
              <div v-if="option.label === 'Status'" class="mo-tooltip-container ml-1">
                <button
                  type="button"
                  class="mo-help-button"
                >
                  i
                </button>
                <div class="mo-tooltip">
                  Open - New order, has not been sent to any provider (FilterEasy, Omni, RushOrder, etc)<br /><br />Sent for shipment - Order has been sent to provider to be fulfilled<br /><br />Shipped - Order has been shipped by provider<br /><br />Delivered - Order has been delivered<br /><br />On hold - Waiting for order to be reviewed by internal user before realising to provider<br /><br />Error - There was an error sending to provider<br /><br />Ignore - Order items that not need shipment (subscription/shipping fees/etc)<br /><br />Waiting for review - Partner pilot orders waiting to be reviewed by internal user before releasing to provider<br /><br />Do not ship - Flagged for bad order or possible scam<br /><br />Payment Pending - Partner order invoice has been created, awaiting payment
                </div>
              </div>
            </div>
            <div class="grid-column even ai-c">
              <div
                v-for="(sub, idx) in option.options"
                :key="idx"
                :class="['mr-1', 'mb-1']"
                @click="updateFilter(sub, option.key)"
              >
                <button
                  type="button"
                  :class="[
                    sub.showIcon ? 'select-button-2' : 'select-button',
                    isOptionActive(option.activeOption, sub, option.multiple) ? 'active' : '',
                  ]"
                >
                  <img
                    v-if="sub.showIcon"
                    alt="size-24"
                    class="img-size-24"
                  >
                  <div>{{ sub.label }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showSidebar"
        class="sb-action"
      >
        <div class="sb-column">
          <div
            class="img-circle"
            @click="resetFilters()"
          >
            <img
              src="@shared/assets/img/general/trash.png"
              alt="x"
              class="img-size-24"
            >
          </div>
          <div class="sac__font-12 semi-bold">
            Clear
          </div>
        </div>
        <div class="sb-column">
          <div
            class="img-circle"
            @click="applyFilters()"
          >
            <img
              src="@shared/assets/img/general/check-black.png"
              alt="x"
              class="img-size-14"
            >
          </div>
          <div class="sac__font-12 semi-bold">
            Apply
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import _ from 'lodash';
import orderMixin from '@shared/mixins/orderMixin';

export default {
  name: 'AllLeadFilterOptions',
  mixins: [orderMixin],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    update: Function,
  },
  data() {
    return {
      orderFilter: _.cloneDeep(this.data),
    };
  },
  computed: {
    showSidebar: {
      get() {
        return this.show;
      },
      set(value) {
        this.$store.dispatch('changeOrderValue', {
          field: 'showRightSidebar',
          value,
        });
      },
    },
  },
  watch: {
    show(show) {
      this.showSidebar = show;
      if (show) {
        document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      } else {
        document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      }
    },
    data(updated) {
      this.orderFilter = _.cloneDeep(updated);
    },
  },
  methods: {
    updateFilter(option, key) {
      this.orderFilter.forEach((fo) => {
        if (fo.key === key) {
          if (key === 'leadType') {
            let activeOptions = fo.activeOption;
            const optionExist = activeOptions.find((ao) => ao.value === option.value);
            if (optionExist) {
              activeOptions = activeOptions.filter((ao) => ao.value !== option.value);
            } else {
              activeOptions = [...activeOptions, option];
            }
            fo.active = true;
            fo.activeOption = [...activeOptions];
          } else {
            fo.active = true;
            fo.activeOption = option;
          }
        }
      });
    },
    async resetFilters() {
      const newFilters = this.orderFilters.map((filter) => {
        if (filter.key !== 'orderDate' && filter.key !== 'techs') {
          filter.active = false;
          filter.activeOption = {};
        }
        return filter;
      });
      await this.update(newFilters);
      this.showSidebar = false;
    },
    applyFilters() {
      const mergedArray = _.unionBy(this.orderFilter, this.orderFilters, 'key');

      const keyOrder = _.map(this.orderFilters, 'key');

      const orderedMergedArray = _.orderBy(mergedArray, (item) => _.indexOf(keyOrder, item.key));
      this.update(orderedMergedArray);
      this.showSidebar = false;
    },
    isOptionActive(activeOption, option, multiple) {
      if (multiple) {
        const optionExist = activeOption.find((ao) => ao.value === option.value);
        return !!optionExist;
      }
      return activeOption.value === option.value;
    },
  },
};
</script>

<style lang="scss" scoped>

.right-sidebar {
  display: flex;
  flex-direction: column;
  background-color: $WHITE;
  width: 0;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  transition: 0.2s ease-out;
  z-index: 999;
  justify-content: space-between;

  &.show {
    width: 450px;
  }

  .mo-tooltip-container {
    position: relative;
    display: flex;
    align-items: center;

    .mo-help-button {
      &:hover {
        &+.mo-tooltip {
          opacity: 1;
          pointer-events: auto;
        }
      }
    }

    .mo-tooltip {
      opacity: 0;
      position: absolute;
      top: 8px;
      left: 19px;
      width: 350px;
      font-size: 0.75em;
      color: $N80;
      background-color: $SUNSET100;
      padding: 4px 10px;
      transition: opacity 250ms ease-in;
      z-index: 100;
      pointer-events: none;
    }
  }

  .mo-help-button {
    width: 17px;
    height: 17px;
    background-color: $WHITE;
    color: $N90;
    font-size: 0.6em;
    border-radius: 50%;
    border: 1px solid black;
    font-weight: 700;
    padding-top: 1px;
  }

  .sidebar-content {
    overflow: hidden;

    .sb-top {
      padding: 68px 40px 0 40px;
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;

      .f-34 {
        font-size: 34px;
        font-weight: bold;
        color: $BLACK;
      }
    }

    .sb-body {
      display: grid;
      gap: 36px;
      height: 90vh;
      padding: 52px 40px 220px 40px;
      overflow: auto;
      -ms-overflow-style: none;
      /* IE and Edge */
      scrollbar-width: none;

      /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .sb-action {
      display: grid;
      grid-auto-flow: column;
      justify-content: center;
      align-items: center;
      gap: 34px;
      position: absolute;
      height: 104px;
      width: 100%;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.9);
      border-top: 1px solid $N5;

      .sb-column {
        display: grid;
        justify-items: center;
        cursor: pointer;

        .img-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: grid;
          align-items: center;
          justify-content: center;
          background-color: $N5;
        }
      }
    }
  }
}
</style>
